export default __webpack_public_path__ + "src/assets/Coinbase_Mobile.ddc8cec1327e7d7bd1b7abea69ea7152.svg";